import React, { useState, useEffect, useRef, useCallback } from "react";
import LogoSVG from "./Images/Logo.svg";
import * as Elements from "./elements.js";
import { useLocation } from "react-router-dom";
import { AiFillHome } from "react-icons/ai";
import { MdSpaceDashboard } from "react-icons/md";
import { BsCalculatorFill } from "react-icons/bs";
import { MdOutlineSwapCalls } from "react-icons/md";
import { FiMenu } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";

function NavbarComponent(props) {
	const [isNavbarOpen, setIsNavbarOpen] = useState(window.innerWidth <= 476 ? false : true);

	const HomePageLink = useRef();
	const DashboardPageLink = useRef();
	const CalculatorPageLink = useRef();
	const SwapPageLink = useRef();
	const CurrentPage = useLocation();
	const AppContainerRef = props.AppContainerRef;

	function OpenNavbar() {
		setIsNavbarOpen(true);
		window.innerWidth <= 476 ? (AppContainerRef.current.style.paddingLeft = "40px") : (AppContainerRef.current.style.paddingLeft = "170px");
		AppContainerRef.current.style.paddingTop = "0px";
	}

	const CloseNavbar = useCallback(() => {
		setIsNavbarOpen(false);
		AppContainerRef.current.style.paddingLeft = "40px";
		AppContainerRef.current.style.paddingTop = "60px";
	}, [AppContainerRef]);

	useEffect(() => {
		const pageLinks = [HomePageLink, DashboardPageLink, CalculatorPageLink, SwapPageLink];
		const currentPathname = CurrentPage.pathname;
		const originPathnameLength = window.location.origin.length;
		for (let i = 0; i < pageLinks.length; i++) {
			const pageLink = pageLinks[i];
			const pageLinkHREF = pageLink.current.href.substring(originPathnameLength);
			if (pageLinkHREF === currentPathname) {
				pageLink.current.classList.add("currentPageLink");
			}
		}

		const windowResizeListener = window.addEventListener("resize", () => {
			if (window.innerWidth <= 476) {
				CloseNavbar();
			}
		});

		return () => window.removeEventListener("resize", windowResizeListener);
	}, [CurrentPage, CloseNavbar]);

	return (
		<Elements.Container isNavbarOpen={isNavbarOpen}>
			<Elements.ContainerInner isNavbarOpen={isNavbarOpen}>
				<Elements.LogoContainer isNavbarOpen={isNavbarOpen}>
					<Elements.LogoImg src={LogoSVG} />
				</Elements.LogoContainer>
				<Elements.LinkContainer isNavbarOpen={isNavbarOpen}>
					<Elements.Link ref={HomePageLink} href="/">
						<AiFillHome />
					</Elements.Link>
					<Elements.Link ref={DashboardPageLink} href="/dashboard">
						<MdSpaceDashboard />
					</Elements.Link>
					<Elements.Link ref={CalculatorPageLink} href="/calculator">
						<BsCalculatorFill />
					</Elements.Link>
					<Elements.Link ref={SwapPageLink} href="/swap">
						<MdOutlineSwapCalls />
					</Elements.Link>
				</Elements.LinkContainer>
				<Elements.ButtonContainer isNavbarOpen={isNavbarOpen}>
					{isNavbarOpen ? (
						<Elements.Button onClick={() => CloseNavbar()}>
							<IoMdClose />
						</Elements.Button>
					) : (
						<Elements.Button onClick={() => OpenNavbar()}>
							<FiMenu />
						</Elements.Button>
					)}
				</Elements.ButtonContainer>
			</Elements.ContainerInner>
		</Elements.Container>
	);
}

export default NavbarComponent;
